<section class="main-container">
  <div class="home-content">
    <!-- predispositions -->
    <section class="section">
      <app-predispositions-table
        [title]="'page.home.predispositions.title' | translate"
        [dataSource]="predispositionsDataSource"
        [filters]="predispositionsFilters"
      ></app-predispositions-table>
    </section>

    <!-- not ordered RISK table -->
    <section
      class="section"
      *ngIf="
        (predispositionsDataSource.loading$ | async) === false &&
        (notOrderedRisksDataSource.loading$ | async) === false &&
        notOrderedRisksDataSource.getData().length > 0
      "
    >
      <app-not-ordered-risk-table
        [title]="'page.home.notOrderedRisk' | translate"
        [dataSource]="notOrderedRisksDataSource"
        [filters]="notOrderedRisksFilters"
        [hasPredispositions]="predispositionsDataSource.getData().length > 0"
      ></app-not-ordered-risk-table>
    </section>
  </div>
</section>
